export type GuestType = 'LOCAL' | 'FOREIGNER';

export default class RoomSearchCriteria {
    private checkInDate: string;
    private checkOutDate: string;
    private numberOfRooms: number;
    private guestType: GuestType;

    constructor(checkInDate:string, checkOutDate:string, numberOfRooms:number, guestType:GuestType) {
        this.checkInDate = checkInDate;
        this.checkOutDate = checkOutDate;
        this.numberOfRooms = numberOfRooms;
        this.guestType = guestType;
    }

    getCheckInDate():string {
        return this.checkInDate;
    }

    getCheckOutDate():string {
        return this.checkOutDate;
    }

    getGuestType():GuestType {
        return this.guestType;
    }

    getNumberOfRooms(): number {
        return this.numberOfRooms;
    }
}